import React, { useContext, useState } from 'react';
import { bool, func, string } from 'prop-types';
import classNames from 'classnames/bind';
import { Button, Loader, Image, Placeholder } from '@thd-olt-component-react/core-ui';
import { StorePodContext } from '../../StorePod.context';
import { analytics } from '../../analytics';
import styles from './store-pod-localize.module.scss';

const cx = classNames.bind(styles);

/* istanbul ignore next */
const setUserLocalStore = ({ id }) => {
  const localizerRequest = {
    storeId: id,
    localizationMethod: 'change store overlay'
  };

  // eslint-disable-next-line no-unused-expressions
  window?.THD_LOCALIZER_AUTO_INIT?.Localizer.localize(localizerRequest)
    .then(() => {
      const urlParams = new URLSearchParams(window?.location?.search);
      if (urlParams.has('URL')) {
        let redirectURL = urlParams.get('URL');
        if (redirectURL !== '') {
          redirectURL = decodeURIComponent(redirectURL).replace(/amp;/g, '');
          window.location = redirectURL;
        }
      } else {
        // eslint-disable-next-line no-unused-expressions
        window?.location?.reload();
      }
    })
    .catch((error) => {
    });
};

export const StorePodLocalize = ({ className, dark, onClick }) => {
  const [isSelectingStore, setIsSelectingStore] = useState(false);
  const { isCanadianStore, isDesignStore, loading, store } = useContext(StorePodContext);

  const { storeId } = store;

  const handleClick = ({ id }) => {
    onClick();
    setIsSelectingStore(true);
    setUserLocalStore({ id });
    analytics.triggerAnalytics();
  };

  const buttonClass = cx({ 'store-pod-localize--filled-in': isSelectingStore });

  if (loading) {
    return (
      <div className={cx(className, 'store-pod-localize')}>
        <Placeholder height="40px" />
      </div>
    );
  }

  return (
    <div className={cx(className, 'store-pod-localize')}>
      {isCanadianStore && (
        <div className={cx('store-pod-localize__wrapper')}>
          <Image
            alt="canadian flag"
            className={cx('store-pod-localize__flag')}
            asset="canada_flag.png"
          />
          <span>
            To shop online at this store, please visit our Canadian site&nbsp;
            <a
              href="//homedepot.ca"
              alt="home depot canadaian"
              className={cx('store-pod-localize__flag-link')}
            >
              homedepot.ca
            </a>
          </span>
        </div>
      )}
      {isDesignStore && (
        <div className={cx('store-pod-localize__wrapper')}>
          <div className={cx('store-pod-localize__hddc')}>
            <span className={cx('store-pod-localize__description')}>The Home Depot Design Center</span>
            <span className={cx('store-pod-localize__footer')}>TM</span>
          </div>
          <span>Design your new kitchen & bath with more brands + dedicated, complimentary services.</span>
        </div>
      )}
      {!isDesignStore && !isCanadianStore && (
        <Button
          className={buttonClass}
          dark={dark}
          onClick={() => handleClick({ id: storeId })}
          outline={dark}
          data-testid="store-pod-localize__button"
        >
          {isSelectingStore && (
            <div className={cx('store-pod-localize__wrapper')}>
              <Loader active bttn className={cx('store-pod-localize__loader')} />
              <span>Selecting This Store...</span>
            </div>
          )}
          {!isSelectingStore && (
            <span>Shop This Store</span>
          )}
        </Button>
      )}
    </div>
  );
};

StorePodLocalize.displayName = 'StorePodLocalize';

StorePodLocalize.propTypes = {
  className: string,
  dark: bool,
  onClick: func
};

StorePodLocalize.defaultProps = {
  className: null,
  dark: false,
  onClick: () => {}
};
